import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    sidebar_opened: true
};

export default {mutations, actions, state}